'use client';

// module imports
import { usePathname } from 'next/navigation';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// file imports
import { SidebarLayout } from '@/components';

export default function LayoutClient({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const protectedRoutes = ['/dashboard', '/profile', '/presentations', '/events', '/leads', '/community', '/settings', '/billing', '/help', '/referral', '/roadmap'];
  const isProtectedRoute = protectedRoutes.some((route) => pathname.startsWith(route));

  // Admin routes - let admin layout handle these
  const isAdminRoute = pathname.startsWith('/admin');

  // public routes
  const noSidebar = pathname === '/login' || pathname === '/register' || pathname === '/email-verified' || pathname === '/forgot-password' || pathname === '/reset-password' || pathname === '/';

  // If it's an admin route, don't wrap with SidebarLayout - let admin layout handle it
  if (isAdminRoute) {
    return (
      <>
        {children}
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" className="!text-sm sm:!text-base" toastClassName="!text-sm sm:!text-base" />
      </>
    );
  }

  if (noSidebar || !isProtectedRoute) {
    return (
      <>
        {children}
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" className="!text-sm sm:!text-base" toastClassName="!text-sm sm:!text-base" />
      </>
    );
  }

  // Protected content with sidebar
  return (
    <SidebarLayout>
      {children}
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" className="!text-sm sm:!text-base" toastClassName="!text-sm sm:!text-base" />
    </SidebarLayout>
  );
}
